var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as moment from 'moment-timezone';
import { BaseComponent } from "../../views/base.component";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { TranslateService } from "../../translate/translate.service";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute, Router } from "@angular/router";
import { ChartParams } from "../../views/chart/chart.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { DepartedTableDetail } from "./departed_table_detail";
import { BuyingChartDetail } from "./BuyingChartDetail";
import { HelperService } from "../../lib/helper.service";
import { DomainsService } from "../domains.service";
var ExpiredDomainsComponent = /** @class */ (function (_super) {
    __extends(ExpiredDomainsComponent, _super);
    function ExpiredDomainsComponent(eventsService, activatedRoute, translate, router, filter, modalService, helper, domainsService) {
        var _this = _super.call(this, eventsService, domainsService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.filter = filter;
        _this.modalService = modalService;
        _this.helper = helper;
        _this.domainsService = domainsService;
        _this.addFilterParams = {
            userType: 'user',
            period: 'month'
        };
        // absolute relative
        _this.chartGroupType = 'absolute';
        _this.buyingChart = new ChartParams({
            groups: ['Active', 'Expired', 'Free', 'Renew', 'Removed']
        });
        _this.attachChart = new ChartParams();
        _this.attachChartExcludeFreeZones = true;
        _this.realAliveChart = new ChartParams({
            chartType: 'bar'
        });
        _this.sslChart = new ChartParams();
        _this.departedChart = new ChartParams();
        _this.departedTable = {
            comebackTotal: 0,
            comeback: [],
            departedTotal: 0,
            departed: []
        };
        _this.tableType = 'departed';
        var me = _this;
        me.buyingChart.setOptions({
            title: me.__a('billing.expired_domains.bought from us'),
            names: {
                Attach: me.__a('billing.expired_domains.Attach'),
                Disconnect: me.__a('billing.expired_domains.Disconnect'),
                Left: me.__a('billing.expired_domains.Left'),
                Park: me.__a('billing.expired_domains.Park'),
                Dead: me.__a('billing.expired_domains.Dead'),
                Alive: me.__a('billing.expired_domains.Alive'),
                RealAlive: me.__a('billing.expired_domains.RealAlive')
            },
            colors: {
                'Active': '#1f77b4',
                'Expired': '#ffa500',
                'Free': '#ff0000',
                'Renew': '#008000',
                'Removed': '#8C8C8C'
            },
            chartType: 'bar',
            events: {
                onclick: function (e) {
                    var index = e.index + 1, dates = me.buyingChart.data[0];
                    me.showBuyingChartDetail(moment(dates[index]).format('YYYY-MM-DD'));
                }
            }
        });
        me.attachChart.setOptions({
            title: me.__a('billing.expired_domains.Attach and Disconnect'),
            names: {
                Attach: me.__a('billing.expired_domains.Attach'),
                Disconnect: me.__a('billing.expired_domains.Disconnect'),
                Left: me.__a('billing.expired_domains.Left'),
                Park: me.__a('billing.expired_domains.Park'),
                Dead: me.__a('billing.expired_domains.Dead'),
                Alive: me.__a('billing.expired_domains.Alive'),
                RealAlive: me.__a('billing.expired_domains.RealAlive')
            },
            showLabels: [
                'Attach', 'Disconnect', 'Alive', 'RealAlive'
            ],
            axes: {
                Alive: 'y',
                Attach: 'y2',
                Disconnect: 'y2',
                Left: 'y2',
                Park: 'y2',
                Dead: 'y2',
                RealAlive: 'y2'
            },
            axis: {
                y2: {
                    show: true
                }
            }
        });
        me.realAliveChart.setOptions({
            title: me.__a('billing.expired_domains.RealAlive'),
            names: {
                RealAlive: me.__a('billing.expired_domains.RealAlive')
            },
            colors: {
                RealAlive: '#e377c2'
            }
        });
        me.sslChart.setOptions({
            title: me.__a('billing.expired_domains.SSL'),
            names: {
                Attach: me.__a('billing.expired_domains.SSL')
            }
        });
        me.departedChart.setOptions({
            title: me.__a('billing.expired_domains.history departed domains stats'),
            names: {
                Attach: me.__a('billing.expired_domains.Attach'),
                Disconnect: me.__a('billing.expired_domains.Disconnect'),
                Left: me.__a('billing.expired_domains.Left'),
                Park: me.__a('billing.expired_domains.Park'),
                Dead: me.__a('billing.expired_domains.Dead'),
                Alive: me.__a('billing.expired_domains.Alive'),
                RealAlive: me.__a('billing.expired_domains.RealAlive')
            },
            chartType: 'bar',
            groups: ['Left', 'Park', 'Dead'],
            colors: {
                'Left': '#ffa500',
                'Park': '#1f77b4',
                'Dead': '#ff0000'
            },
        });
        return _this;
    }
    ExpiredDomainsComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.attachChartExcludeFreeZones = this.filter.filterParams['attachChartExcludeFreeZones'] ? this.filter.filterParams['attachChartExcludeFreeZones'] : true;
                        return [4 /*yield*/, this.getBuyingChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getAttachChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getRealAliveChart()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getSslChart()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getDepartedChart()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.getDepartedTable()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.getBuyingChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.buyingChart.showLoader();
                        return [4 /*yield*/, this.domainsService.expired.chart(this.filter.filterParams, 'buying_chart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.buyingChart.data = charts;
                        this.buyingChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.excludeFreeZonesCheckChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAttachChart()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.getAttachChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filter.filterParams['attachChartExcludeFreeZones'] = this.attachChartExcludeFreeZones;
                        this.attachChart.showLoader();
                        return [4 /*yield*/, this.domainsService.expired.chart(this.filter.filterParams, 'attach/chart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.attachChart.data = charts;
                        this.attachChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.getRealAliveChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.realAliveChart.showLoader();
                        return [4 /*yield*/, this.domainsService.expired.chart(this.filter.filterParams, 'real_alive/chart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.realAliveChart.data = charts;
                        this.realAliveChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.getSslChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sslChart.showLoader();
                        return [4 /*yield*/, this.domainsService.expired.chart(this.filter.filterParams, 'ssl/chart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.sslChart.data = charts;
                        this.sslChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.getDepartedChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.departedChart.showLoader();
                        return [4 /*yield*/, this.domainsService.expired.chart(this.filter.filterParams, 'departed/chart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.departedChart.data = charts;
                        this.departedChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.getDepartedTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.domainsService.expired.stats(this.filter.filterParams, 'departed/stats').toPromise()];
                    case 1:
                        _a.departedTable = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.showBuyingChartDetail = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            var me, modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        modalRef = me.modalService.open(BuyingChartDetail, {
                            title: date,
                            isLoad: true,
                        }, { size: 'hg' });
                        return [4 /*yield*/, me.domainsService.expired.detail(me.filter.getCopyFilterParams({ date: date, }), 'buying_chart/detail').toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.stats = stats;
                        modalRef.componentInstance.isLoad = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredDomainsComponent.prototype.showDepartedTableDetail = function (stat) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(DepartedTableDetail, {
                            title: stat.moveTo,
                            isLoad: true,
                            tableType: this.tableType
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.domainsService.expired.detail(this.filter.getCopyFilterParams({
                                ns: stat.moveTo,
                                tableType: this.tableType
                            }), 'moveto_detail').toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.stats = stats;
                        modalRef.componentInstance.isLoad = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return ExpiredDomainsComponent;
}(BaseComponent));
export { ExpiredDomainsComponent };
